import { Helmet } from "react-helmet-async";
import Hero from "../components/Hero";
import SearchBar from "../components/SearchBar";
import PopularDestinations from "../components/PopularDestinations";
import TopRatedHotels from "../components/TopRatedHotels";
import HotelList from "../components/HotelList";
import WhyChooseUs from "../components/WhyChooseUs";
import BlogSection from "../components/BlogSection";
import Testimonials from "../components/Testimonials";
import TrustedPartners from "../components/TrustedPartners";
import CTASection from "../components/CTASection";
import heroImg from "../assests/images/hero.jpg";

export default function Home() {
  return (
    <div>

      {/* SEO FOR HOMEPAGE */}
      <Helmet>
        <title>
          South Travels Hotels | Best Hotels & Luxury Stays Worldwide
        </title>

        <meta
          name="description"
          content="Book luxury hotels, resorts, and stays worldwide with South Travels Hotels. Best deals on top-rated accommodations and travel experiences."
        />

        <link
          rel="canonical"
          href="https://hotel.southtravels.com/"
        />

        {/* Open Graph */}
        <meta property="og:title" content="South Travels Hotels | Best Hotels & Luxury Stays Worldwide" />
        <meta property="og:description" content="Book luxury hotels, resorts, and stays worldwide with South Travels Hotels." />
        <meta property="og:url" content="https://hotel.southtravels.com/" />
        <meta property="og:type" content="website" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="South Travels Hotels | Best Hotels & Luxury Stays Worldwide" />
        <meta name="twitter:description" content="Book luxury hotels, resorts, and stays worldwide with South Travels Hotels." />

        <meta name="robots" content="index, follow" />
      </Helmet>

      {/* HERO */}
      <Hero
        variant="home"
        title="Find Your Perfect Stay"
        subtitle="Explore the best hotels, resorts, and travel experiences across top destinations worldwide."
        backgroundImage={heroImg}
      />

      {/* SEARCH */}
      <div className="relative z-20">
        <SearchBar />
      </div>

      {/* SECTIONS */}
      <PopularDestinations limit={4} showViewAllButton={true} />
      <TopRatedHotels limit={3} />
      <HotelList showSidebar={false} limit={6} showViewAllButton={true} showBanner={false} showHeading={true} />
      <WhyChooseUs />
      <BlogSection />
      <Testimonials />
      <TrustedPartners />
      <CTASection />

    </div>
  );
}